/**
 * Skin Quiz JavaScript
 */
(function() {
  'use strict';

  const SkinQuiz = {
    currentStep: 0,
    totalSteps: 7,
    answers: {},

    init: function() {
      this.quiz = document.getElementById('skinQuiz');
      if (!this.quiz) return;

      this.steps = this.quiz.querySelectorAll('.quiz-step');
      this.bindEvents();
    },

    bindEvents: function() {
      // Start button
      const startBtn = this.quiz.querySelector('[data-action="start"]');
      if (startBtn) {
        startBtn.addEventListener('click', () => this.goToStep(1));
      }

      // Navigation buttons
      this.quiz.querySelectorAll('[data-action="next"]').forEach(btn => {
        btn.addEventListener('click', () => this.nextStep());
      });

      this.quiz.querySelectorAll('[data-action="back"]').forEach(btn => {
        btn.addEventListener('click', () => this.prevStep());
      });

      // Submit button
      const submitBtn = this.quiz.querySelector('[data-action="submit"]');
      if (submitBtn) {
        submitBtn.addEventListener('click', () => this.submitQuiz());
      }

      // Option selection - Radio buttons
      this.quiz.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', (e) => this.handleRadioSelection(e));
      });

      // Option selection - Checkboxes
      this.quiz.querySelectorAll('input[type="checkbox"][name="concerns"]').forEach(input => {
        input.addEventListener('change', (e) => this.handleCheckboxSelection(e));
      });

      // Email input
      const emailInput = this.quiz.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener('input', () => this.validateEmail());
      }
    },

    goToStep: function(stepIndex) {
      // Hide current step
      this.steps[this.currentStep].classList.remove('active');
      
      // Show new step
      this.currentStep = stepIndex;
      this.steps[this.currentStep].classList.add('active');

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    nextStep: function() {
      if (this.currentStep < this.totalSteps) {
        this.goToStep(this.currentStep + 1);
      }
    },

    prevStep: function() {
      if (this.currentStep > 0) {
        this.goToStep(this.currentStep - 1);
      }
    },

    handleRadioSelection: function(e) {
      const input = e.target;
      const name = input.name;
      const value = input.value;
      
      // Store answer
      this.answers[name] = value;

      // Enable next button for current step
      const currentStepEl = this.steps[this.currentStep];
      const nextBtn = currentStepEl.querySelector('[data-action="next"]');
      if (nextBtn) {
        nextBtn.disabled = false;
      }

      // Auto-advance to next step after a short delay for better UX
      // Don't auto-advance on the email step (step 6)
      if (this.currentStep < this.totalSteps) {
        setTimeout(() => {
          this.nextStep();
        }, 400);
      }
    },

    handleCheckboxSelection: function(e) {
      const currentStepEl = this.steps[this.currentStep];
      const checkboxes = currentStepEl.querySelectorAll('input[type="checkbox"][name="concerns"]');
      const checkedBoxes = currentStepEl.querySelectorAll('input[type="checkbox"][name="concerns"]:checked');
      
      // Store answers
      this.answers.concerns = Array.from(checkedBoxes).map(cb => cb.value);

      // Enable next button if at least one is selected
      const nextBtn = currentStepEl.querySelector('[data-action="next"]');
      if (nextBtn) {
        nextBtn.disabled = checkedBoxes.length === 0;
      }
    },

    validateEmail: function() {
      const emailInput = this.quiz.querySelector('input[type="email"]');
      const submitBtn = this.quiz.querySelector('[data-action="submit"]');
      
      if (emailInput && submitBtn) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailRegex.test(emailInput.value);
        submitBtn.disabled = !isValid;
      }
    },

    submitQuiz: async function() {
      const emailInput = this.quiz.querySelector('input[type="email"]');
      const marketingCheckbox = this.quiz.querySelector('input[name="marketing"]');
      const submitBtn = this.quiz.querySelector('[data-action="submit"]');
      const errorContainer = this.quiz.querySelector('.quiz-error');
      
      // Clear previous errors
      if (errorContainer) {
        errorContainer.textContent = '';
        errorContainer.style.display = 'none';
      }
      
      if (emailInput) {
        this.answers.email = emailInput.value;
      }
      
      if (marketingCheckbox) {
        this.answers.marketing = marketingCheckbox.checked;
      }

      // Prepare the data payload with the required field names
      const payload = {
        howOldAreYou: this.answers.age || '',
        whatsYourSkinType: this.answers.skin_type || '',
        howDoesYourSkinFeel: this.answers.skin_feel || '',
        whatIsYourMainSkincareGoal: this.answers.skincare_goal || '',
        iWantMySkincareRoutineToBe: this.answers.routine_preference || '',
        email: this.answers.email || '',
        acceptMarketing: this.answers.marketing || false
      };

      console.log('Quiz Payload:', payload);

      // Disable submit button and show loading state
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'SUBMITTING...';
      }

      try {
        const response = await fetch('/apps/roadmap-app/form-submission?handle=skin-quiz', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `Submission failed with status ${response.status}`);
        }

        const result = await response.json().catch(() => ({}));
        console.log('Quiz submission successful:', result);
        
        // Show success page
        this.showResults();
        
      } catch (error) {
        console.error('Quiz submission error:', error);
        
        // Show error message
        if (errorContainer) {
          errorContainer.textContent = error.message || 'Something went wrong. Please try again.';
          errorContainer.style.display = 'block';
        }
        
        // Re-enable submit button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'SEE MY RESULTS';
        }
      }
    },

    showResults: function() {
      // Navigate to success step
      this.goToStep(7);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => SkinQuiz.init());
  } else {
    SkinQuiz.init();
  }
})();